/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
export const DataAnnotationOrigin = {
    EXTERNAL: "EXTERNAL",
    MANUAL: "MANUAL",
    MODEL: "MODEL",
};
export const DataAnnotationStatus = {
    COMPLETE: "COMPLETE",
    PARTIAL: "PARTIAL",
    NONE: "NONE",
};
export const DataArrayDataType = {
    Bool: "Bool",
    I8: "I8",
    I16: "I16",
    I32: "I32",
    I64: "I64",
    U8: "U8",
    U16: "U16",
    U32: "U32",
    U64: "U64",
    F16: "F16",
    F32: "F32",
    F64: "F64",
};
export const DataCompatibilityStatus = {
    COMPATIBLE: "COMPATIBLE",
    INCOMPATIBLE: "INCOMPATIBLE",
};
export const DataCompressionInfo = {
    ApplicationXLz4: "application/x-lz4",
    ApplicationZstd: "application/zstd",
    ApplicationIdentity: "application/identity",
};
export const DataExamplePickingStrategy = {
    RANDOM: "RANDOM",
    LATEST: "LATEST",
};
export const DataImageMode = {
    LU8: "L_U8",
    LF32: "L_F32",
    LF64: "L_F64",
    LAU8: "LA_U8",
    LAF32: "LA_F32",
    LAF64: "LA_F64",
    RGBU8: "RGB_U8",
    RGBF32: "RGB_F32",
    RGBF64: "RGB_F64",
    RGBAU8: "RGBA_U8",
    RGBAF32: "RGBA_F32",
    RGBAF64: "RGBA_F64",
    BGRU8: "BGR_U8",
    BGRF32: "BGR_F32",
    BGRF64: "BGR_F64",
    BGRAU8: "BGRA_U8",
    BGRAF32: "BGRA_F32",
    BGRAF64: "BGRA_F64",
    YCbCrU8: "YCbCr_U8",
    BayerRGU8: "BayerRG_U8",
    BayerRGU10: "BayerRG_U10",
    BayerRGU12: "BayerRG_U12",
    JPEG: "JPEG",
    PNG: "PNG",
    GIF: "GIF",
    BMP: "BMP",
};
export const DataPixelDataLayout = {
    HeightWidthChannels: "HeightWidthChannels",
    ChannelsHeightWidth: "ChannelsHeightWidth",
};
export const DataSplitStrategy = {
    RANDOM: "RANDOM",
    STRATIFIED: "STRATIFIED",
};
export const DataTransformationMode = {
    JpegImages: "JpegImages",
};
import axios from "axios";
import qs from "qs";
export var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
    ContentType["Text"] = "text/plain";
})(ContentType || (ContentType = {}));
export class HttpClient {
    instance;
    securityData = null;
    securityWorker;
    secure;
    format;
    constructor({ securityWorker, secure, format, ...axiosConfig } = {}) {
        this.instance = axios.create({
            ...axiosConfig,
            baseURL: axiosConfig.baseURL || "/datastore/api/v1",
            paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "indices" }),
        });
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    setSecurityData = (data) => {
        this.securityData = data;
    };
    mergeRequestParams(params1, params2) {
        const method = params1.method || (params2 && params2.method);
        return {
            ...this.instance.defaults,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...((method && this.instance.defaults.headers[method.toLowerCase()]) || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }
    stringifyFormItem(formItem) {
        if (typeof formItem === "object" && formItem !== null) {
            return JSON.stringify(formItem);
        }
        else {
            return `${formItem}`;
        }
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            const propertyContent = property instanceof Array ? property : [property];
            for (const formItem of propertyContent) {
                const isFileType = formItem instanceof Blob || formItem instanceof File;
                formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
            }
            return formData;
        }, new FormData());
    }
    request = async ({ secure, path, type, query, format, body, ...params }) => {
        const secureParams = ((typeof secure === "boolean" ? secure : this.secure) &&
            this.securityWorker &&
            (await this.securityWorker(this.securityData))) ||
            {};
        const requestParams = this.mergeRequestParams(params, secureParams);
        const responseFormat = format || this.format || undefined;
        if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
            body = this.createFormData(body);
        }
        if (type === ContentType.UrlEncoded && body && body !== null && typeof body === "object") {
            body = qs.stringify(body);
        }
        if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
            body = JSON.stringify(body);
        }
        return this.instance.request({
            ...requestParams,
            headers: {
                ...(requestParams.headers || {}),
                ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
            },
            params: query,
            responseType: responseFormat,
            data: body,
            url: path,
        });
    };
}
/**
 * @title Robovision Datastore
 * @version 0.1.0
 * @baseUrl /datastore/api/v1
 */
export class Api extends HttpClient {
    embeddings = {
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags samples-examples, embeddings
         * @name DeleteEmbeddings
         * @summary Delete the selected embeddings
         * @request POST:/embeddings/batch-delete
         * @secure
         */
        deleteEmbeddings: (data, params = {}) => this.request({
            path: `/embeddings/batch-delete`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags samples-examples, embeddings
         * @name ListSampleEmbeddings
         * @summary List the embeddings for the specified sample
         * @request GET:/embeddings/{sample_id}
         * @secure
         */
        listSampleEmbeddings: (sampleId, params = {}) => this.request({
            path: `/embeddings/${sampleId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags samples-examples, embeddings
         * @name DeleteEmbedding
         * @summary Delete the specified embedding
         * @request DELETE:/embeddings/{sample_id}/{node_id}/{embedding_name}
         * @secure
         */
        deleteEmbedding: (sampleId, nodeId, embeddingName, params = {}) => this.request({
            path: `/embeddings/${sampleId}/${nodeId}/${embeddingName}`,
            method: "DELETE",
            secure: true,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags samples-examples, embeddings
         * @name GetEmbedding
         * @summary Fetch the specified embedding
         * @request GET:/embeddings/{sample_id}/{node_id}/{embedding_name}
         * @secure
         */
        getEmbedding: (sampleId, nodeId, embeddingName, params = {}) => this.request({
            path: `/embeddings/${sampleId}/${nodeId}/${embeddingName}`,
            method: "GET",
            secure: true,
            format: "arraybuffer",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags samples-examples, embeddings
         * @name AddEmbedding
         * @summary Fetch the specified embedding
         * @request POST:/embeddings/{sample_id}/{node_id}/{embedding_name}
         * @secure
         */
        addEmbedding: (sampleId, nodeId, embeddingName, data, params = {}) => this.request({
            path: `/embeddings/${sampleId}/${nodeId}/${embeddingName}`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.FormData,
            ...params,
        }),
    };
    livez = {
        /**
         * No description
         *
         * @name IsLive
         * @summary Liveness probe for the datastore
         * @request GET:/livez
         */
        isLive: (params = {}) => this.request({
            path: `/livez`,
            method: "GET",
            ...params,
        }),
    };
    nodeThumbnails = {
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags samples-examples
         * @name GetSampleNodeThumbnail
         * @summary Get the thumbnail for the specified data sample
         * @request GET:/node-thumbnails/{sample_id}/{node_id}/{profile}
         * @secure
         */
        getSampleNodeThumbnail: (sampleId, nodeId, profile, query, params = {}) => this.request({
            path: `/node-thumbnails/${sampleId}/${nodeId}/${profile}`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        }),
    };
    pools = {
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name ListPools
         * @summary List all datapools in the datastore
         * @request GET:/pools
         * @secure
         */
        listPools: (query, params = {}) => this.request({
            path: `/pools`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * PROJECT_CREATION
         *
         * @tags datapools
         * @name CreatePool
         * @summary Create a new datapool
         * @request POST:/pools
         * @secure
         */
        createPool: (data, params = {}) => this.request({
            path: `/pools`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * PROJECT_CREATION
         *
         * @tags datapools
         * @name DeletePool
         * @summary Delete the specified datapool and all containing data
         * @request DELETE:/pools/{pool_id}
         * @secure
         */
        deletePool: (poolId, params = {}) => this.request({
            path: `/pools/${poolId}`,
            method: "DELETE",
            secure: true,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags samples-examples
         * @name GetAnnotation
         * @summary Get the specified annotation record
         * @request GET:/pools/{pool_id}/annotations/{sample_id}/{source_id}
         * @secure
         */
        getAnnotation: (poolId, sampleId, sourceId, query, params = {}) => this.request({
            path: `/pools/${poolId}/annotations/${sampleId}/${sourceId}`,
            method: "GET",
            query: query,
            secure: true,
            format: "arraybuffer",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name ListPoolClasses
         * @summary List the classes present in the specified datapool
         * @request GET:/pools/{pool_id}/classes
         * @secure
         */
        listPoolClasses: (poolId, query, params = {}) => this.request({
            path: `/pools/${poolId}/classes`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name CountPoolClasses
         * @summary Count the classes present in the specified datapool
         * @request GET:/pools/{pool_id}/classes/count
         * @secure
         */
        countPoolClasses: (poolId, query, params = {}) => this.request({
            path: `/pools/${poolId}/classes/count`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name CountCachedPoolClasses
         * @summary Get a (possibly outdated) cached count of classes present in the specified datapool
         * @request GET:/pools/{pool_id}/classes/count/cache
         * @secure
         */
        countCachedPoolClasses: (poolId, params = {}) => this.request({
            path: `/pools/${poolId}/classes/count/cache`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD PROJECT_CREATION * INFERENCE PROJECT_CREATION * LABELING_REVIEW PROJECT_CREATION
         *
         * @tags datapools
         * @name ClonePool
         * @summary Create a clone of the specified datapool
         * @request POST:/pools/{pool_id}/clone
         * @secure
         */
        clonePool: (poolId, data, params = {}) => this.request({
            path: `/pools/${poolId}/clone`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags samples-examples
         * @name CopyAnnotations
         * @summary Copy selected annotations from a given source to another source
         * @request POST:/pools/{pool_id}/copy-annotations
         * @secure
         */
        copyAnnotations: (poolId, data, query, params = {}) => this.request({
            path: `/pools/${poolId}/copy-annotations`,
            method: "POST",
            query: query,
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name GetPoolExampleDefinition
         * @summary Get the example definition of a pool
         * @request GET:/pools/{pool_id}/example-definition
         * @secure
         */
        getPoolExampleDefinition: (poolId, query, params = {}) => this.request({
            path: `/pools/${poolId}/example-definition`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * PROJECT_CREATION
         *
         * @tags datapools
         * @name UpdatePoolExampleDefinition
         * @summary Update the example definition of a pool
         * @request PATCH:/pools/{pool_id}/example-definition
         * @secure
         */
        updatePoolExampleDefinition: (poolId, data, params = {}) => this.request({
            path: `/pools/${poolId}/example-definition`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * LABELING_REVIEW
         *
         * @tags datapools
         * @name AddExample
         * @summary Add a example to a given datapool
         * @request POST:/pools/{pool_id}/examples
         * @secure
         */
        addExample: (poolId, query, data, params = {}) => this.request({
            path: `/pools/${poolId}/examples`,
            method: "POST",
            query: query,
            body: data,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags samples-examples
         * @name DeleteAnnotations
         * @summary Delete the specified examples
         * @request POST:/pools/{pool_id}/examples/batch-delete
         * @secure
         */
        deleteAnnotations: (poolId, data, params = {}) => this.request({
            path: `/pools/${poolId}/examples/batch-delete`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags samples-examples
         * @name InvalidateAnnotations
         * @summary Invalidate the specified examples without removing them
         * @request POST:/pools/{pool_id}/examples/batch-invalidate
         * @secure
         */
        invalidateAnnotations: (poolId, data, params = {}) => this.request({
            path: `/pools/${poolId}/examples/batch-invalidate`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name CountExamplesClasses
         * @summary Count the classes present in the specified example
         * @request POST:/pools/{pool_id}/examples/classes/count
         * @secure
         */
        countExamplesClasses: (poolId, data, query, params = {}) => this.request({
            path: `/pools/${poolId}/examples/classes/count`,
            method: "POST",
            query: query,
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags samples-examples
         * @name GetExample
         * @summary Get the specified example record
         * @request GET:/pools/{pool_id}/examples/{sample_id}/{source_id}
         * @secure
         */
        getExample: (poolId, sampleId, sourceId, query, params = {}) => this.request({
            path: `/pools/${poolId}/examples/${sampleId}/${sourceId}`,
            method: "GET",
            query: query,
            secure: true,
            format: "arraybuffer",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags samples-examples
         * @name GetExampleDescription
         * @summary Get the specified example record's description
         * @request GET:/pools/{pool_id}/examples/{sample_id}/{source_id}/description
         * @secure
         */
        getExampleDescription: (poolId, sampleId, sourceId, query, params = {}) => this.request({
            path: `/pools/${poolId}/examples/${sampleId}/${sourceId}/description`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags datapools, tags
         * @name ListFilteredPoolTags
         * @summary List all tags in the specified datapool
         * @request POST:/pools/{pool_id}/filtered-tags
         * @secure
         */
        listFilteredPoolTags: (poolId, data, params = {}) => this.request({
            path: `/pools/${poolId}/filtered-tags`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name CheckPoolLabelCompatibility
         * @summary Check if the specified labels are compatible with the pool
         * @request POST:/pools/{pool_id}/label-compatibility
         * @secure
         */
        checkPoolLabelCompatibility: (poolId, data, params = {}) => this.request({
            path: `/pools/${poolId}/label-compatibility`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name GetPoolMetadata
         * @summary Get the metadata of a pool
         * @request GET:/pools/{pool_id}/metadata
         * @secure
         */
        getPoolMetadata: (poolId, query, params = {}) => this.request({
            path: `/pools/${poolId}/metadata`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * PROJECT_CREATION
         *
         * @tags datapools
         * @name UpdatePoolMetadata
         * @summary Update the metadata of a pool
         * @request PUT:/pools/{pool_id}/metadata
         * @secure
         */
        updatePoolMetadata: (poolId, data, params = {}) => this.request({
            path: `/pools/${poolId}/metadata`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name GetCachedPoolMetadata
         * @summary Get a (possibly outdated) cached version of the metadata of a pool
         * @request GET:/pools/{pool_id}/metadata/cache
         * @secure
         */
        getCachedPoolMetadata: (poolId, params = {}) => this.request({
            path: `/pools/${poolId}/metadata/cache`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name ListPoolSampleMetadata
         * @summary List metadata of all samples that are present in the specified datapool
         * @request GET:/pools/{pool_id}/sample-metadata
         * @secure
         */
        listPoolSampleMetadata: (poolId, query, params = {}) => this.request({
            path: `/pools/${poolId}/sample-metadata`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name ListPoolSamples
         * @summary List all samples that are present in the specified datapool
         * @request GET:/pools/{pool_id}/samples
         * @secure
         */
        listPoolSamples: (poolId, query, params = {}) => this.request({
            path: `/pools/${poolId}/samples`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * LABELING_REVIEW
         *
         * @tags datapools
         * @name AddSample
         * @summary Add a sample to a given datapool
         * @request POST:/pools/{pool_id}/samples
         * @secure
         */
        addSample: (poolId, query, data, params = {}) => this.request({
            path: `/pools/${poolId}/samples`,
            method: "POST",
            query: query,
            body: data,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name ListPoolSamplesWithIntersection
         * @summary List all samples that are present in the specified datapool
         * @request POST:/pools/{pool_id}/samples-intersection
         * @secure
         */
        listPoolSamplesWithIntersection: (poolId, data, params = {}) => this.request({
            path: `/pools/${poolId}/samples-intersection`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags samples-examples
         * @name BulkUpdateAnnotations
         * @summary Patch the specified samples with new records in bulk
         * @request PATCH:/pools/{pool_id}/samples/annotations
         * @secure
         */
        bulkUpdateAnnotations: (poolId, query, data, params = {}) => this.request({
            path: `/pools/${poolId}/samples/annotations`,
            method: "PATCH",
            query: query,
            body: data,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags samples-examples
         * @name BulkOverwriteAnnotations
         * @summary Overwrite the annotations of the specified samples with new records in bulk
         * @request PUT:/pools/{pool_id}/samples/annotations
         * @secure
         */
        bulkOverwriteAnnotations: (poolId, query, data, params = {}) => this.request({
            path: `/pools/${poolId}/samples/annotations`,
            method: "PUT",
            query: query,
            body: data,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * LABELING_REVIEW
         *
         * @tags samples-examples
         * @name DeleteSamples
         * @summary Delete the specified samples
         * @request POST:/pools/{pool_id}/samples/batch-delete
         * @secure
         */
        deleteSamples: (poolId, data, params = {}) => this.request({
            path: `/pools/${poolId}/samples/batch-delete`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * LABELING_REVIEW
         *
         * @tags samples-examples
         * @name InvalidateSamples
         * @summary Invalidate the specified samples without removing them
         * @request POST:/pools/{pool_id}/samples/batch-invalidate
         * @secure
         */
        invalidateSamples: (poolId, data, params = {}) => this.request({
            path: `/pools/${poolId}/samples/batch-invalidate`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags samples-examples
         * @name ListSamplesClasses
         * @summary List the classes present for the filtered samples
         * @request POST:/pools/{pool_id}/samples/classes
         * @secure
         */
        listSamplesClasses: (poolId, data, params = {}) => this.request({
            path: `/pools/${poolId}/samples/classes`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags samples-examples
         * @name CountSamplesClasses
         * @summary Count the classes present for the filtered samples
         * @request POST:/pools/{pool_id}/samples/classes/count
         * @secure
         */
        countSamplesClasses: (poolId, data, params = {}) => this.request({
            path: `/pools/${poolId}/samples/classes/count`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name CountPoolSamples
         * @summary Count all samples that are present in the specified datapool matching the filters
         * @request GET:/pools/{pool_id}/samples/count
         * @secure
         */
        countPoolSamples: (poolId, query, params = {}) => this.request({
            path: `/pools/${poolId}/samples/count`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name CountPoolSamplesWithIntersection
         * @summary Count all samples that are present in the specified datapool matching the filters
         * @request POST:/pools/{pool_id}/samples/count-intersection
         * @secure
         */
        countPoolSamplesWithIntersection: (poolId, data, params = {}) => this.request({
            path: `/pools/${poolId}/samples/count-intersection`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags samples-examples
         * @name UpdateFilteredAnnotations
         * @summary Update the annotations of the specified samples with new records in bulk
         * @request PATCH:/pools/{pool_id}/samples/filtered-annotations
         * @secure
         */
        updateFilteredAnnotations: (poolId, query, data, params = {}) => this.request({
            path: `/pools/${poolId}/samples/filtered-annotations`,
            method: "PATCH",
            query: query,
            body: data,
            secure: true,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags samples-examples
         * @name OverwriteFilteredAnnotations
         * @summary Overwrite the annotations of the specified samples with new records in bulk
         * @request PUT:/pools/{pool_id}/samples/filtered-annotations
         * @secure
         */
        overwriteFilteredAnnotations: (poolId, query, data, params = {}) => this.request({
            path: `/pools/${poolId}/samples/filtered-annotations`,
            method: "PUT",
            query: query,
            body: data,
            secure: true,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * LABELING_REVIEW
         *
         * @tags datapools
         * @name AddImageSample
         * @summary Add an image as sample to a given datapool
         * @request POST:/pools/{pool_id}/samples/image
         * @secure
         */
        addImageSample: (poolId, query, data, params = {}) => this.request({
            path: `/pools/${poolId}/samples/image`,
            method: "POST",
            query: query,
            body: data,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags samples-examples
         * @name GetSample
         * @summary Get the specified sample record
         * @request GET:/pools/{pool_id}/samples/{sample_id}
         * @secure
         */
        getSample: (poolId, sampleId, query, params = {}) => this.request({
            path: `/pools/${poolId}/samples/${sampleId}`,
            method: "GET",
            query: query,
            secure: true,
            format: "arraybuffer",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags samples-examples
         * @name UpdateAnnotations
         * @summary Patch a specified sample with a new record
         * @request PATCH:/pools/{pool_id}/samples/{sample_id}/annotations
         * @secure
         */
        updateAnnotations: (poolId, sampleId, query, data, params = {}) => this.request({
            path: `/pools/${poolId}/samples/${sampleId}/annotations`,
            method: "PATCH",
            query: query,
            body: data,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags samples-examples
         * @name OverwriteAnnotations
         * @summary Overwrite the annotations of a specified sample with a new record
         * @request PUT:/pools/{pool_id}/samples/{sample_id}/annotations
         * @secure
         */
        overwriteAnnotations: (poolId, sampleId, query, data, params = {}) => this.request({
            path: `/pools/${poolId}/samples/${sampleId}/annotations`,
            method: "PUT",
            query: query,
            body: data,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags samples-examples
         * @name GetSampleDescription
         * @summary Get the specified sample record's description
         * @request GET:/pools/{pool_id}/samples/{sample_id}/description
         * @secure
         */
        getSampleDescription: (poolId, sampleId, query, params = {}) => this.request({
            path: `/pools/${poolId}/samples/${sampleId}/description`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags datapools, tags
         * @name ListSampleTags
         * @summary List all tags that are assigned to the given sample
         * @request GET:/pools/{pool_id}/samples/{sample_id}/tags
         * @secure
         */
        listSampleTags: (poolId, sampleId, query, params = {}) => this.request({
            path: `/pools/${poolId}/samples/${sampleId}/tags`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags datapools, datasets
         * @name ListPoolSets
         * @summary List all the datasets defined on the specified datapool
         * @request GET:/pools/{pool_id}/sets
         * @secure
         */
        listPoolSets: (poolId, query, params = {}) => this.request({
            path: `/pools/${poolId}/sets`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * MODEL_CREATION
         *
         * @tags datapools, datasets
         * @name CreateSets
         * @summary Define a new dataset (split) on the specified datapool
         * @request POST:/pools/{pool_id}/sets
         * @secure
         */
        createSets: (poolId, data, params = {}) => this.request({
            path: `/pools/${poolId}/sets`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name ListPoolSources
         * @summary List the sources present in the specified datapool
         * @request GET:/pools/{pool_id}/sources
         * @secure
         */
        listPoolSources: (poolId, query, params = {}) => this.request({
            path: `/pools/${poolId}/sources`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name ListFilteredPoolSources
         * @summary List the sources present in the specified datapool for the filtered samples
         * @request POST:/pools/{pool_id}/sources
         * @secure
         */
        listFilteredPoolSources: (poolId, data, params = {}) => this.request({
            path: `/pools/${poolId}/sources`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags datapools, tags
         * @name ListPoolTags
         * @summary List all tags in the specified datapool
         * @request GET:/pools/{pool_id}/tags
         * @secure
         */
        listPoolTags: (poolId, query, params = {}) => this.request({
            path: `/pools/${poolId}/tags`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags datapools, tags
         * @name CreateTag
         * @summary Create new tags in the specified datapool
         * @request POST:/pools/{pool_id}/tags
         * @secure
         */
        createTag: (poolId, data, params = {}) => this.request({
            path: `/pools/${poolId}/tags`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
    };
    sets = {
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags datasets
         * @name ListSetsForSchema
         * @summary List all datasets that are compatible with the schema in the specified example definition
         * @request POST:/sets/list-for-schema
         * @secure
         */
        listSetsForSchema: (data, query, params = {}) => this.request({
            path: `/sets/list-for-schema`,
            method: "POST",
            query: query,
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * MODEL_CREATION
         *
         * @tags datasets
         * @name DeleteSet
         * @summary Delete the specified dataset
         * @request DELETE:/sets/{set_id}
         * @secure
         */
        deleteSet: (setId, params = {}) => this.request({
            path: `/sets/${setId}`,
            method: "DELETE",
            secure: true,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datasets
         * @name GetSetAnnotation
         * @summary Get the specified annotation record from the given dataset
         * @request GET:/sets/{set_id}/annotations/{sample_id}
         * @secure
         */
        getSetAnnotation: (setId, sampleId, params = {}) => this.request({
            path: `/sets/${setId}/annotations/${sampleId}`,
            method: "GET",
            secure: true,
            format: "arraybuffer",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags datasets
         * @name ListSetClasses
         * @summary List the classes present in the specified dataset
         * @request GET:/sets/{set_id}/classes
         * @secure
         */
        listSetClasses: (setId, query, params = {}) => this.request({
            path: `/sets/${setId}/classes`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags datasets
         * @name CountSetClasses
         * @summary Count the classes present in the specified dataset
         * @request GET:/sets/{set_id}/classes/count
         * @secure
         */
        countSetClasses: (setId, query, params = {}) => this.request({
            path: `/sets/${setId}/classes/count`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags datasets
         * @name CountCachedSetClasses
         * @summary Get a (possibly outdated) cached count of classes present in the specified dataset
         * @request GET:/sets/{set_id}/classes/count/cache
         * @secure
         */
        countCachedSetClasses: (setId, params = {}) => this.request({
            path: `/sets/${setId}/classes/count/cache`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags datasets
         * @name GetSetExampleDefinition
         * @summary Get the example definition of a set
         * @request GET:/sets/{set_id}/example-definition
         * @secure
         */
        getSetExampleDefinition: (setId, params = {}) => this.request({
            path: `/sets/${setId}/example-definition`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags datasets
         * @name ListSetExamples
         * @summary List the examples present in the specified dataset
         * @request GET:/sets/{set_id}/examples
         * @secure
         */
        listSetExamples: (setId, query, params = {}) => this.request({
            path: `/sets/${setId}/examples`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags datasets
         * @name ListSetExamplesWithIntersection
         * @summary List the examples present in the specified dataset
         * @request POST:/sets/{set_id}/examples-intersection
         * @secure
         */
        listSetExamplesWithIntersection: (setId, data, params = {}) => this.request({
            path: `/sets/${setId}/examples-intersection`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags datasets
         * @name CountSetExamplesClasses
         * @summary Count the classes present in the requested examples in a set
         * @request POST:/sets/{set_id}/examples/classes/count
         * @secure
         */
        countSetExamplesClasses: (setId, data, params = {}) => this.request({
            path: `/sets/${setId}/examples/classes/count`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags datasets
         * @name CountSetExamples
         * @summary Count the examples present in the specified dataset matching the filters
         * @request GET:/sets/{set_id}/examples/count
         * @secure
         */
        countSetExamples: (setId, query, params = {}) => this.request({
            path: `/sets/${setId}/examples/count`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags datasets
         * @name CountSetExamplesWithIntersection
         * @summary Count the examples present in the specified dataset matching the filters
         * @request POST:/sets/{set_id}/examples/count-intersection
         * @secure
         */
        countSetExamplesWithIntersection: (setId, data, params = {}) => this.request({
            path: `/sets/${setId}/examples/count-intersection`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datasets
         * @name GetSetExample
         * @summary Get the specified example record from the given dataset
         * @request GET:/sets/{set_id}/examples/{sample_id}
         * @secure
         */
        getSetExample: (setId, sampleId, query, params = {}) => this.request({
            path: `/sets/${setId}/examples/${sampleId}`,
            method: "GET",
            query: query,
            secure: true,
            format: "arraybuffer",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datasets
         * @name GetSetExampleDescription
         * @summary Get the specified example record's description
         * @request GET:/sets/{set_id}/examples/{sample_id}/description
         * @secure
         */
        getSetExampleDescription: (setId, sampleId, params = {}) => this.request({
            path: `/sets/${setId}/examples/${sampleId}/description`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags datasets
         * @name GetSetMetadata
         * @summary Get the metadata of a set
         * @request GET:/sets/{set_id}/metadata
         * @secure
         */
        getSetMetadata: (setId, params = {}) => this.request({
            path: `/sets/${setId}/metadata`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * MODEL_CREATION
         *
         * @tags datasets
         * @name UpdateSetMetadata
         * @summary Update the metadata of a set
         * @request PUT:/sets/{set_id}/metadata
         * @secure
         */
        updateSetMetadata: (setId, data, params = {}) => this.request({
            path: `/sets/${setId}/metadata`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags datasets
         * @name GetCachedSetMetadata
         * @summary Get a (possible outdated) cached version of the metadata of a set
         * @request GET:/sets/{set_id}/metadata/cache
         * @secure
         */
        getCachedSetMetadata: (setId, params = {}) => this.request({
            path: `/sets/${setId}/metadata/cache`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datasets
         * @name GetSetSample
         * @summary Get the specified sample record from the given dataset
         * @request GET:/sets/{set_id}/samples/{sample_id}
         * @secure
         */
        getSetSample: (setId, sampleId, params = {}) => this.request({
            path: `/sets/${setId}/samples/${sampleId}`,
            method: "GET",
            secure: true,
            format: "arraybuffer",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags datasets
         * @name ListSetSources
         * @summary List the sources present in the specified dataset
         * @request GET:/sets/{set_id}/sources
         * @secure
         */
        listSetSources: (setId, params = {}) => this.request({
            path: `/sets/${setId}/sources`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags datasets, tags
         * @name ListSetTags
         * @summary List all tags in the datapool linked to the specified dataset
         * @request GET:/sets/{set_id}/tags
         * @secure
         */
        listSetTags: (setId, query, params = {}) => this.request({
            path: `/sets/${setId}/tags`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
    };
    tags = {
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags tags
         * @name ListTags
         * @summary List all tags
         * @request GET:/tags
         * @secure
         */
        listTags: (query, params = {}) => this.request({
            path: `/tags`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags tags
         * @name DeleteTag
         * @summary Delete the specified tag
         * @request DELETE:/tags/{tag_id}
         * @secure
         */
        deleteTag: (tagId, params = {}) => this.request({
            path: `/tags/${tagId}`,
            method: "DELETE",
            secure: true,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags tags
         * @name GetTagMetadata
         * @summary Get the metadata of a tag
         * @request GET:/tags/{tag_id}/metadata
         * @secure
         */
        getTagMetadata: (tagId, params = {}) => this.request({
            path: `/tags/${tagId}/metadata`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags tags
         * @name UpdateTagMetadata
         * @summary Update the metadata of a tag
         * @request PUT:/tags/{tag_id}/metadata
         * @secure
         */
        updateTagMetadata: (tagId, data, params = {}) => this.request({
            path: `/tags/${tagId}/metadata`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags tags
         * @name GetCachedTagMetadata
         * @summary Get a (possible outdated) cached version of the metadata of a tag
         * @request GET:/tags/{tag_id}/metadata/cache
         * @secure
         */
        getCachedTagMetadata: (tagId, params = {}) => this.request({
            path: `/tags/${tagId}/metadata/cache`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags tags
         * @name TagPoolSamples
         * @summary Tag samples with a given tag
         * @request POST:/tags/{tag_id}/samples/batch-pool-add
         * @secure
         */
        tagPoolSamples: (tagId, data, params = {}) => this.request({
            path: `/tags/${tagId}/samples/batch-pool-add`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags tags
         * @name UntagPoolSamples
         * @summary Untag the samples from the given tag
         * @request POST:/tags/{tag_id}/samples/batch-pool-delete
         * @secure
         */
        untagPoolSamples: (tagId, data, params = {}) => this.request({
            path: `/tags/${tagId}/samples/batch-pool-delete`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD INFERENCE * INFERENCE LABELING_REVIEW * MODEL_CREATION
         *
         * @tags tags
         * @name TagSetSamples
         * @summary Tag samples with a given tag
         * @request POST:/tags/{tag_id}/samples/batch-set-add
         * @secure
         */
        tagSetSamples: (tagId, data, params = {}) => this.request({
            path: `/tags/${tagId}/samples/batch-set-add`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD INFERENCE * INFERENCE LABELING_REVIEW * MODEL_CREATION
         *
         * @tags tags
         * @name UntagSetSamples
         * @summary Untag the samples from the given tag
         * @request POST:/tags/{tag_id}/samples/batch-set-delete
         * @secure
         */
        untagSetSamples: (tagId, data, params = {}) => this.request({
            path: `/tags/${tagId}/samples/batch-set-delete`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
    };
    thumbnails = {
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags samples-examples
         * @name GetThumbnail
         * @summary Get the thumbnail for the specified data sample
         * @request GET:/thumbnails/{sample_id}
         * @secure
         */
        getThumbnail: (sampleId, query, params = {}) => this.request({
            path: `/thumbnails/${sampleId}`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        }),
    };
}
//# sourceMappingURL=data:application/json;base64,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